import React from 'react'
import { IconType, } from 'react-icons'
import { ComponentType } from 'react'
import { LucideProps } from 'lucide-react'
import './ConfigureNotification.css'

interface ConfigureNotificationProps{
title:string,
description:string,
Icon: ComponentType<LucideProps>
bgColor?: string   // cor de fundo opcional
textColor?: string // cor do texto opcional
iconColor?:string
enabled: boolean
onToogle: (next: boolean) => void;
onEdit: () => void;
}

const ConfigureNotification: React.FC<ConfigureNotificationProps> = ({
    title,
    description,
    Icon,
    bgColor = '',
    textColor = '',
    iconColor='',
    enabled,
    onToogle,
    onEdit
}) => {
  return (
    <div className='configure-notification' style={{ backgroundColor: bgColor, color: textColor }}>
        <div style={{marginTop: '5px', marginRight:'10px'}}>
            <Icon size={24} color={iconColor}/>
        </div>
        <div className='configure-notification-body'>
            <span className='configure-notification__title'>{title}</span>
            <h5 className='configure-notification__description'>{description}</h5>
        </div>

        <div className='configure-notification-actions'>
            {/* switch built-in (input[type=checkbox]) estilizado */}
            <label className="toggle-switch">
                <input type="checkbox" checked={enabled} onChange={e=>onToogle(e.target.checked)}/>
                <span className="slider" />
            </label>

            <button className="btn-edit" style={{color:iconColor}} onClick={onEdit}>
                Editar
            </button>
        </div>
    </div>
  )
}

export default ConfigureNotification
